import { DEFAULT_EMPTY } from '@/utils/constant'
import Byd from '@/utils/Byd.js'

/**
 * 获取URL上search中的sign参数
 * @returns {string} - sign参数值
 */
export const getSignFromUrl = () => {
  const search = window.location.search
  if (!search) return ''
  const params = new URLSearchParams(search)
  return params.get('sign') || ''
}

/**
 * 获取用户相关信息
 * @param {Object} instance - 组件实例（this）
 * @returns {Promise} - 成功返回 {code: 200, data: {...}}, 失败返回 reject
 */
export const getUserRealtiveInfo = ({instance}) => {
  return new Promise((resolve, reject) => {
    let bridgeSuccessCount = 0
    const totalBridges = 2

    const checkAllSuccess = () => {
      if (bridgeSuccessCount === totalBridges) {
        resolve({ vin: instance.vinValue, carSeries: instance.modelValue, userID: instance.userID })
      }
    }

    // 调用桥1：获取默认车辆信息
    Byd.getUserDefaultVehicleInfo({channel:4},{
      success: (res) => {
        if (res.code===200) {
          console.log('getUserDefaultVehicleInfo res.code===200==>',res.data)
          instance.vinValue = res.data.vin
          // APP上车辆信息中给用户看到的车型名称，是文档中的outModelType 外部车型
          instance.modelValue = res.data.outModelType
          bridgeSuccessCount++
          checkAllSuccess()
        } else {
          console.log('getUserDefaultVehicleInfo res.code不等于200',res)
          reject(new Error('获取车辆信息失败'))
        }
      },
      fail: (err) => {
        console.log('getUserDefaultVehicleInfo 请求失败',err)
        reject(new Error('获取车辆信息失败'))
      }
    })

    // 调用桥2：获取腾讯IM登录信息
    Byd.getTencentIMLoginInf({},{
      success: (res) => {
        if (res.code===200) {
          console.log('getTencentIMLoginInf res.code===200==>',res.data)
          instance.userID = res.data.IMuserId
          bridgeSuccessCount++
          checkAllSuccess()
        } else {
          console.log('getTencentIMLoginInf res.code不等于200',res)
          reject(new Error('获取IM登录信息失败'))
        }
      },
      fail: (err) => {
        console.log('getTencentIMLoginInf 请求失败',err)
        reject(new Error('获取IM登录信息失败'))
      }
    })
  })
}

/**
 * 处理VIN查询结果并直接更新组件实例属性
 * @param {Object} instance - 组件实例（this）
 * @param {Object} resultData - 查询结果数据
 * @param {string} defaultFailMsg - 默认失败消息
 */
export const updateQueryResult = ({instance, defaultFailMsg,response,isApp=false}) => {
    instance.isLoading = false
    instance.isSuccess = true
    instance.resultData = response

    console.log('Final resultData:', instance.resultData)
    console.log('resultData keys:', Object.keys(instance.resultData))
    console.log('resultData has version:', instance.resultData.hasOwnProperty('version'))
    console.log('resultData has end_date:', instance.resultData.hasOwnProperty('end_date'))
  // 如果接口返回车型信息，更新modelValue
  // 链接查询结果中的车型和车架号优先以 app 的结果为准，如果app 没有结果以后端结果为主
  if(isApp) {
     // eslint-disable-next-line no-empty
     if(instance.modelValue) {
        // 这里不能return， 函数还要继续执行
     }else{
        instance.modelValue=instance.resultData.carSeries||DEFAULT_EMPTY
     }
  }else if (instance.resultData.carSeries) {
    instance.modelValue = instance.resultData.carSeries
  } else{
    instance.modelValue = DEFAULT_EMPTY
  }
  // 如果接口返回vin信息，更新vinValue
  if(isApp) {
    if(instance.vinValue) {
        // 这里不能return， 函数还要继续执行
     }else{
        instance.vinValue=instance.resultData.vin||DEFAULT_EMPTY
     }
  } else if (instance.resultData.vin) {
    instance.vinValue = instance.resultData.vin
  } else {
    instance.vinValue = DEFAULT_EMPTY
  }
  /**
   * 失败：
   * resultData:false ：未查询到车辆信息
   * result:{} 返回空对象
   * resultData && resultData.only_vehicle_info_reason: 有车辆信息但是没有召回或者ota升级信息
   * 因为成功的插槽要渲染成功的各种信息的比如升级时间，召回时间等
  */
  if(!instance.resultData || (instance.resultData && Object.keys(instance.resultData).length <= 0)|| (instance.resultData && instance.resultData.only_vehicle_info_reason)) {
    instance.isSuccess = false
    instance.isFail = true
    instance.failMessage = instance.resultData && instance.resultData.only_vehicle_info_reason?instance.resultData.only_vehicle_info_reason:defaultFailMsg
  }
}


/**
 * 解析 extension 字段（JSON 字符串）为普通对象数组
 * @param {string|undefined|null} extensionStr - extension 字段的 JSON 字符串
 * @returns {Array} 解析后的审核历史数组，解析失败时返回空数组
 */
export function parseExtension(extensionStr) {
  // 防御性检查：参数不存在或非字符串
  if (!extensionStr || typeof extensionStr !== 'string') {
    return {}
  }
  
  try {
    const parsed = JSON.parse(extensionStr)
    return parsed
  } catch (error) {
    // JSON 解析失败
    console.error('解析 extension 失败:', error)
    return {}
  }
}


/**
 * 处理VIN查询结果并直接更新组件实例属性
 * @param {Object} instance - 组件实例（this）
 * @param {Object} resultData - 查询结果数据
 * @param {string} defaultFailMsg - 默认失败消息
 */
export const updateQueryResultForHistory = ({instance, defaultFailMsg,response}) => {
    instance.isLoading = false
    instance.isSuccess = true
    instance.resultData = response
    Object.assign(instance.resultData, parseExtension(instance?.resultData?.extension))
    console.log('updateQueryResultForHistory Final resultData:', instance.resultData)
    console.log('updateQueryResultForHistory resultData keys:', Object.keys(instance.resultData))
    console.log('updateQueryResultForHistory resultData has version:', instance.resultData.hasOwnProperty('version'))
    console.log('updateQueryResultForHistory resultData has end_date:', instance.resultData.hasOwnProperty('end_date'))
  // 如果接口返回车型信息，更新modelValue

  if (instance.resultData.car_series) {
    instance.modelValue = instance.resultData.car_series
  } else{
    instance.modelValue = DEFAULT_EMPTY
  }
  // 如果接口返回vin信息，更新vinValue
if (instance.resultData.vin) {
    instance.vinValue = instance.resultData.vin
  } else {
    instance.vinValue = DEFAULT_EMPTY
  }
  /**
   * 失败：
   * resultData:false ：未查询到车辆信息
   * result:{} 返回空对象
   * resultData && resultData.only_vehicle_info_reason: 有车辆信息但是没有召回或者ota升级信息
   * 因为成功的插槽要渲染成功的各种信息的比如升级时间，召回时间等
  */
  if(!instance.resultData || (instance.resultData && Object.keys(instance.resultData).length <= 0)|| (instance.resultData && instance?.resultData?.only_vehicle_info_reason)) {
    instance.isSuccess = false
    instance.isFail = true
    instance.failMessage = instance?.resultData?.only_vehicle_info_reason||defaultFailMsg
  }
}